import React, { useEffect } from "react";
import {
  ResumecontentDiv,
  ResumeDivCard,
  ResumeCarImg,
  ResumeCardMeta,
  ResumeCardTitle,
  ResumeCardSubTitle,
  ResumeCardText,
  ResumeContentTitle,
  Links,
} from "./OficialStudies.elements.js";
import uclm from "../../images/uclm.jpg";
import ies from "../../images/ies.png";
import b1 from "../../images/B1.jpg";
import nttdata from "../../images/nttdata.jpg";
import Aos from "aos";
import "aos/dist/aos.css";

export default function OficialStudies({ light }) {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <ResumecontentDiv
        className="resume"
        id="estudios"
        data-aos="fade-zoom-in"
        data-aos-easing="ease-in-back"
        data-aos-delay="200"
        data-aos-offset="0"
      >
        <ResumeContentTitle light={light}>
          TRAYECTORIA
        </ResumeContentTitle>
        <ResumeDivCard>
          <ResumeCarImg src={nttdata} alt="uclm" />
          <ResumeCardMeta>
            <ResumeCardTitle light={light}>
              NTT Data Infrastructures
            </ResumeCardTitle>
            <ResumeCardSubTitle light={light}>
              Área de automatización (2022-Actualidad)
            </ResumeCardSubTitle>
            <ResumeCardText light={light}>
              Empresa en la cual realice las prácticas de la universidad con una duración de 6 meses (febrero-agosto de 2022).
            </ResumeCardText>
          </ResumeCardMeta>
        </ResumeDivCard>
        <ResumeDivCard>
          <ResumeCarImg src={uclm} alt="uclm" />
          <ResumeCardMeta>
            <ResumeCardTitle light={light}>
              Grado en Ingeniería Informática
            </ResumeCardTitle>
            <ResumeCardSubTitle light={light}>
              Universidad de Castilla- La Mancha (2018-2022)
            </ResumeCardSubTitle>
            <ResumeCardText light={light}>
              Realizado en la
              <Links light={light} href="https://esi.uclm.es/" target="_blank">
                <span> </span>Escuela Superior de Infórmatica de Ciudad Real
              </Links>
              , especializado en la intensificación de Tecnologías de la
              Información. 
            </ResumeCardText>
          </ResumeCardMeta>
        </ResumeDivCard>
        <ResumeDivCard>
          <ResumeCarImg src={ies} alt="ies" />
          <ResumeCardMeta>
            <ResumeCardTitle light={light}>
              ESO y Bachillerato De Ciencias Tecnológicas
            </ResumeCardTitle>
            <ResumeCardSubTitle light={light}>
              <Links
                light={light}
                href="http://iesberengueladecastilla.es/"
                target="_blank"
              >
                I.E.S Berenguela de Castilla
              </Links>
              , Bolaños de Calatrava (2012-2018)
            </ResumeCardSubTitle>
            <ResumeCardText light={light}>
              Nota Media Bachiller: 8 pts.
            </ResumeCardText>
            <ResumeCardText light={light}>
              Nota Media EVAU: 10.686 pts.
            </ResumeCardText>
          </ResumeCardMeta>
        </ResumeDivCard>
        <ResumeDivCard>
          <ResumeCarImg src={b1} alt="ies" />
          <ResumeCardMeta>
            <ResumeCardTitle light={light}>
              Cambridge English Level B1
            </ResumeCardTitle>
            <ResumeCardSubTitle light={light}>
              Septiembre 2016
            </ResumeCardSubTitle>
            <ResumeCardText light={light}>
              Overall Score: 142 pts.
            </ResumeCardText>
          </ResumeCardMeta>
        </ResumeDivCard>
      </ResumecontentDiv>
    </>
  );
}
